window._ = require('lodash');
window.axios = require('axios');
import axiosRetry from 'axios-retry';

axiosRetry(window.axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

const token = document.head.querySelector('meta[name="csrf-token"]');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content || '';

window.axios.interceptors.request.use((config) => {

  try {
    if (config.timeout === 0) config.timeout = 300000;
  } catch (error) {};

  return config;
}, (error) => {
  return Promise.reject(error);
});
